module.exports = __webpack_public_path__ + "media/images/icon-product/media-leaflet-5bfac6c8439c1a898ab14253d8eccb16.svg";